module.exports = __webpack_public_path__ + "img/nextspin.73128722.png";